import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Payment from './pages/payment/Payment';

function App() {
  return (
    <Router>
      <Switch>
        <Route path={['/']} component={Payment}/>
      </Switch>
    </Router>
  );
}

export default App;
